<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            Department of Clinic/ ປະເພດລາຄາ
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 9">
        <b-tab-item label="ຈັດການປະເພດລາຄາ">
          <div class="columns">
            <div class="column">
              <h3 class="title">ຈັດການປະເພດລາຄາ</h3>
            </div>
          </div>
          <div class="columns" v-if="adddataform">
            <div class="column">
              <div class="columns">
                <div class="column">
                  <b-field label="ຊື່ປະເພດ">
                    <b-input v-model.trim="priceTypeName"> </b-input>
                  </b-field>
                </div>
                <div class="column">

                </div>
                <div class="column">
                  
                </div>
                <div class="column">
                  
                </div>
                
              </div>
              <div class="columns">
                <div class="column">
                  <b-field label="ລາຄາ-1">
                    <b-input v-model.trim="price1"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ເພີ່ມ-1">
                    <b-input v-model.trim="plus1"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ລາຄາ-2">
                    <b-input v-model.trim="price2"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ເພີ່ມ-2">
                    <b-input v-model.trim="plus2"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ລາຄາ-3">
                    <b-input v-model.trim="price3"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ເພີ່ມ-3">
                    <b-input v-model.trim="plus3"> </b-input>
                  </b-field>
                </div>
                
              </div>
              <div class="columns">
                <div class="column">
                  <b-field label="ລາຄາ-4">
                    <b-input v-model.trim="price4"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ເພີ່ມ-4">
                    <b-input v-model.trim="plus4"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ລາຄາ-5">
                    <b-input v-model.trim="price5"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ເພີ່ມ-5">
                    <b-input v-model.trim="plus5"> </b-input>
                  </b-field>
                </div>
                <div class="column">

                </div>
                <div class="column">
                  
                </div>
                
              </div>
              <div class="columns">
                <div class="column"></div>
                <div class="column">
                  
                  <b-field label="" style="float: right">
                    <b-field v-if="saveAction">
                      <button class="button is-info" @click="saveProductPriceType">
                        ບັນທຶກຂໍ້ມູນ
                      </button>
                    </b-field>
                    <b-field v-if="updateAction">
                      <div class="columns">
                        <div class="column">
                          <b-field>
                            <button
                              class="button is-primary"
                              @click="updateProductPriceType"
                            >
                              ແກ້ໄຂຂໍ້ມູນ
                            </button>
                          </b-field>
                        </div>
                        <div class="column">
                          <b-field>
                            <button
                              class="button is-info"
                              @click="openSaveBranchForm"
                            >
                              ຟອມບັນທຶກຂໍ້ມູນ
                            </button>
                          </b-field>
                        </div>
                      </div>
                    </b-field>
                  </b-field>
                </div>
              </div>
              
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <table class="table is-fullwidth is-narrow is-small" >
                <thead>
                  <tr>
                    <th class="has-text-centered " width="2%">#</th>

                    <th class="has-text-left " width="15%">
                      ປະເພດລາຄາ
                    </th>

                    <th class="has-text-centered " width="8%">
                      ລາຄາ-1
                    </th>
                    <th class="has-text-centered " width="8%">
                      ເພີ່ມ-1
                    </th>

                    <th class="has-text-centered " width="8%">
                      ລາຄາ-2
                    </th>
                    <th class="has-text-centered " width="8%">
                      ເພີ່ມ-2
                    </th>

                    <th class="has-text-centered " width="8%">
                      ລາຄາ-3
                    </th>
                    <th class="has-text-centered " width="8%">
                      ເພີ່ມ-3

                    </th>

                    <th class="has-text-centered " width="8%">
                      ລາຄາ-4
                    </th>
                    <th class="has-text-centered " width="8%">
                      ເພີ່ມ-4
                    </th>

                    <th class="has-text-centered " width="8%">
                      ລາຄາ-5
                    </th>
                    <th class="has-text-centered " width="8%">
                      ເພີ່ມ-5
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in priceTypeList"
                    :key="data.ID"
                  >
                    <td class="has-text-centered">{{ index + 1 }}</td>

                    <td>
                      {{ data.NAME }}  <br>
                      <b-button
                        class="btn-group-margin"
                        type="is-primary"
                        size="is-small"
                        @click="updateProductForm(data)"
                        >ແກ້ໄຂ
                      </b-button>
                    </td>
                    <td class="has-text-right ">
                      {{ data.PRICE1 | formatNumberLocal }} 
                    </td>
                    <td class="has-text-right ">
                      {{ data.PLUS1 | formatNumberLocal }}  
                    </td>
                    <td class="has-text-right ">
                      {{ data.PRICE2 | formatNumberLocal }}  
                    </td>
                    <td class="has-text-right ">
                      {{ data.PLUS2 | formatNumberLocal }}  
                    </td>
                    <td class="has-text-right ">
                      {{ data.PRICE3 | formatNumberLocal }}  
                    </td>
                    <td class="has-text-right ">
                      {{ data.PLUS3 | formatNumberLocal }}  
                    </td>
                    <td class="has-text-right ">
                      {{ data.PRICE4 | formatNumberLocal }}  
                    </td>
                    <td class="has-text-right ">
                      {{ data.PLUS4 | formatNumberLocal }}  
                    </td>
                    <td class="has-text-right ">
                      {{ data.PRICE5 | formatNumberLocal }}  
                    </td>
                    <td class="has-text-right ">
                      {{ data.PLUS5 | formatNumberLocal }}  
                    </td>
                    

                    
                    
                  </tr>
                </tbody>
              </table>

              
            </div>
          </div>
          
        </b-tab-item>

        <b-tab-item label="ສິນຄ້າ">
          <div class="columns">
            <div class="column">
              <b-field style="margin-left: 20px" grouped>
    
              
                <b-field label="ປະເພດສິນຄ້າ">
                  <Multiselect
                    placeholder="ເລືອກ"
                    v-model.trim="selectedTypeSearch"
                    label="NAME"
                    track-by="ID"
                    :options="typeList"
                    @input="productTypeSelectedSearch"
                  >
                  </Multiselect>
                </b-field>
              </b-field>

              <b-field label="ສິນຄ້າ">
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="2%">#</th>

                      <th class="has-text-left " width="15%">
                        ສິນຄ້າ
                      </th>

                      <th class="has-text-left " width="5%">
                        ຫົວໜ່ວຍ
                      </th>
                      <th class="has-text-left " width="5%">
                        ປະເພດ
                      </th>

                      
                      <th class="has-text-left " width="15%">
                        ຮູບ
                      </th>
                      <th class="has-text-centered " width="40%">
                        ປະເພດລາຄາ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in activeproducts"
                      :key="data.PRODUCTID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>

                      <td>
                        {{ data.PRODUCTNAME }}<br>
                        {{ data.PRODUCTNAMEEN }}
                      </td>
                      <td>
                        {{ data.UNIT }}
                      </td>
                      <td>
                        {{ data.PRODUCTTYPENAME }}
                      </td>

                     
                      <td>
                        <!-- {{data.PHOTONAME}} -->
                        <img
                          data-v-xcxcc
                          :src="getImgUrl(data.PHOTONAME)"
                          width="100"
                          height="100"
                        />
                      </td>


                      <td class="has-text-centered">
                        <b-field >
                          <b-field  v-if="data.PRODUCTPRICETYPENAME"> 
                            <b-button
                                  class="is-small btn-group-margin"
                                  type="is-danger"
                                  size="is-small"
                                  @click="unSetProductPriceType(data.PRODUCTPRICETYPEID, data.PRODUCTID)"    
                              >X  
                              </b-button> {{ data.PRODUCTPRICETYPENAME }}
                          </b-field>
                          <!-- <b-field v-for="item in data.PRICETYPE" :key="item.ID" v-else> 
                            
                              <b-button
                                class="btn-group-margin"
                                type="is-success"  
                                size="is-small"
                                @click="setProductPriceType(item.ID, data.PRODUCTID)"
                                ><span style="font-size:16px">{{ item.NAME }}</span>
                              </b-button>
                            
                            <br>
                          </b-field>   -->
                          <b-field v-else>
                            <div style="display: flex; flex-direction: column; gap: 5px;">
                              <b-button
                                v-for="item in data.PRICETYPE"
                                :key="item.ID"
                                class="btn-group-margin"
                                type="is-success"
                                size="is-small"
                                @click="setProductPriceType(item.ID, data.PRODUCTID)"
                              >
                                <span style="font-size:16px">{{ item.NAME }}</span>
                              </b-button>
                            </div>
                          </b-field>
                          
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>

      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
// import axios from "axios";

export default {
  components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      userName: null,
      selectedType: [],
      selectedB2BType: [],
      selectedHarvestSearch :null,

      typeList: [],
      selectedTypeSearch: null,

      activeproducts: [],
      inactiveproducts: [],
      productid: null,
      oldproductname: null,
      productname: null,
      oldproductnameen: null,
      productnameen: null,
      oldunit: null,
      unit: null,
      oldphotoname: null,

      harvesttype: [
        { ID: "1", NAME: "ຄັ້ງດຽວ" },
        { ID: "0", NAME: "ຫຼາຍເທື່ອ" },
      ], 
      selectedHarvesttype: [],

      selectedFile: null,
      url: "uploadimage", // function name in api site
      photoname: null,
      photopath:
        process.env.NODE_ENV === "production"
          ? "https://agrilao.com/manager-main/api/uploads/products/"
          : "http://localhost/agrilao-manager/api/uploads/products/",
      // photopath: process.env.NODE_ENV === "production" ? "http://51.222.85.54/agrilao-manager/api/uploads/products/" : "http://localhost/agrilao-manager/api/uploads/products/",
      photopreview: null,
      isSelectPhoto: false,

      // oldbranchenname: null,
      // branchenname: null,
      // countryid: null,
      // provinceid: null,
      // oldprovinceid: null,
      // responseusername: null,
      // oldresponseusername: null,

      productgrade: null,
      productgrade_eng: null,
      subunit: null,
      oldsubunit: null,
      gradunit: null,
      gradunit_eng: null,
      productgradelist: [],
      productgradecount: 0,
      productgradeid: null,
      isaddgrade: true,
      price: 0,
      productphotoname: null,

      activeTab: 0,
      saveAction: true,
      updateAction: false,
      adddataform: true,
      updatedataform: false,

      recommenttitle: null,
      provinceList: [],
      activeSubTab: 0,
     
      search: null,
      disabledstate: false,

      selectedProductID: null,

      priceTypeList: [],
      priceTypeID: null,
      priceTypeName: null,
      oldPriceTypeName: null,
      price1: null,
      plus1: null,
      price2: null,
      plus2: null,
      price3: null,
      plus3: null,
      price4: null,
      plus4: null,
      price5: null,
      plus5: null,
    };
  },
  methods: {

    updateProductPriceType(){
      if (
        this.priceTypeName === null || this.priceTypeName.length == 0 ||
        this.price1 === null || this.price1.length == 0 ||
        this.plus1 === null ||  this.plus1.length == 0
        
      ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
        return false;

      }

      var params = {
        pricetypeid: this.priceTypeID,
        pricetypename: this.priceTypeName,
        oldpricetypename:  this.oldPriceTypeName,
        price1: this.price1,
        plus1: this.plus1,
        price2: this.price2,
        plus2: this.plus2,
        price3: this.price3,
        plus3: this.plus3,
        price4: this.price4,
        plus4: this.plus4,
        price5: this.price5,
        plus5: this.plus5,
        username: this.username,
      };
      // console.log("params: " + JSON.stringify(params));
      RestAPI.updateProductPriceType(params)
        .then((res) => {
          if (res.data == "duplicate pricetypename") {
            this.$swal("ຊື່ສິນຄ້າຊ້ຳ", "-", "error");
            return false;
          }


          this.$swal("ແກ້ໄຂສິນຄ້າ ສຳເລັດ!", "", "success");
          this.getProductPriceType();

          this.saveAction = true;
          this.updateAction = false;
          this.priceTypeID = null;
          this.priceTypeName = null;
          this.price1 = null;
          this.plus1 = null;
          this.price2 = null; 
          this.plus2 = null;
          this.price3 = null;
          this.plus3 = null;
          this.price4 = null;
          this.plus4 = null;
          this.price5 = null;
          this.plus5 = null;
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
      
    },

    saveProductPriceType(){
      if (
        this.priceTypeName === null || this.priceTypeName.length == 0 ||
        this.price1 === null || this.price1.length == 0 ||
        this.plus1 === null ||  this.plus1.length == 0
        
      ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
        return false;

      }

      var params = {
        pricetypename: this.priceTypeName,
        price1: this.price1,
        plus1: this.plus1,
        price2: this.price2,
        plus2: this.plus2,
        price3: this.price3,
        plus3: this.plus3,
        price4: this.price4,
        plus4: this.plus4,
        price5: this.price5,
        plus5: this.plus5,
        username: this.username,
      };
      // console.log("params: " + JSON.stringify(params));
      RestAPI.saveProductPriceType(params)
        .then((res) => {
          if (res.data == "duplicate pricetypename") {
            this.$swal("ຊື່ສິນຄ້າຊ້ຳ", "-", "error");
            return false;
          }


          this.$swal("ບັນທືກສິນຄ້າ ສຳເລັດ!", "", "success");
          this.getProductPriceType();

          this.priceTypeName = null;
          this.price1 = null;
          this.plus1 = null;
          this.price2 = null; 
          this.plus2 = null;
          this.price3 = null;
          this.plus3 = null;
          this.price4 = null;
          this.plus4 = null;
          this.price5 = null;
          this.plus5 = null;
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
      
    },

    getProductPriceType() {
      const loadingComponent = this.$loading.open({});  
      RestAPI.getProductPriceTypeList()
        .then((res) => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.priceTypeList = res.data;
          loadingComponent.close();
          // this.inactiveproducts = res.data.inactiveproducts;
        })
        .catch((error) => {
          loadingComponent.close();
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });

        
    },
   

    setProductPriceType(PRICETYPEID, PRODUCTID){
      const loadingComponent = this.$loading.open({});
          
      var params = {
        productid: PRODUCTID,
        pricetypeid: PRICETYPEID,
        username: this.username,       
      };

      RestAPI.setProductPriceType(params)
      .then(() => {
        // this.getProducts();
        this.productTypeSelectedSearch();
        loadingComponent.close();  
        
        })     
      .catch((error) => {
        loadingComponent.close();  
        console.log(error);
        if (error == "Error: Request failed with status code 400") {
          this.$swal("Check Input Data", "", "error");
        } else {
          this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
        }
      });
    },

    unSetProductPriceType(PRICETYPEID, PRODUCTID){
      const loadingComponent = this.$loading.open({});
          
      var params = {
        productid: PRODUCTID,
        pricetypeid: PRICETYPEID,
        username: this.username,       
      };

      RestAPI.unSetProductPriceType(params)
      .then(() => {
        // this.getProducts();
        this.productTypeSelectedSearch();
        loadingComponent.close();  
        
        })     
      .catch((error) => {
        loadingComponent.close();  
        console.log(error);
        if (error == "Error: Request failed with status code 400") {
          this.$swal("Check Input Data", "", "error");
        } else {
          this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
        }
      });

      

    },
    getProductTypes() {
      RestAPI.getClinicProductAllTypes()
        .then((res) => {
          // console.log("getClinicProductTypes: " + JSON.stringify(res.data));
          this.typeList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
   
    // saveProduct() {
    //   // console.log("this.selectedProvince.ID: " + this.selectedProvince.length)
    //   if (
    //     this.productname === null ||
    //     this.productnameen === null ||
    //     this.unit === null ||
    //     this.selectedType === null
        
    //   ) {
    //     this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");

    //   }else if (this.selectedType.ISFARMING =='1' && this.selectedHarvesttype === null ){
    //     this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");

    //   } else {
    //     var harvest;
    //     if(this.selectedType.ISFARMING =='1'){
    //       harvest = this.selectedHarvesttype.ID;
    //     }else{
    //       harvest = 2;
    //     }

    //     var params = {
    //       productname: this.productname,
    //       productnameen: this.productnameen,
    //       typeid: this.selectedType.ID,
    //       harvesttype: harvest,
    //       unit: this.unit,
    //       photoname: this.photoname,
    //       username: this.username,
    //     };
    //     // console.log("params: " + JSON.stringify(params));
    //     RestAPI.saveProduct(params)
    //       .then((res) => {
    //         // console.log("data: " + JSON.stringify(res.data))
    //         if (res.data == "duplicate productname") {
    //           this.$swal("ຊື່ສິນຄ້າຊ້ຳ", "-", "error");
    //           return false;
    //         }

    //         this.photopreview = null;
    //         this.$swal("ບັນທືກສິນຄ້າ ສຳເລັດ!", "", "success");

    //         this.productname = null;
    //         this.productnameen = null;
    //         this.unit = null;
    //         this.selectedType = null;
    //         (this.selectedHarvesttype = null), this.getProducts();
    //         this.activeTab = 1;
    //       })
    //       .catch((error) => {
    //         console.log(error);
    //         if (error == "Error: Request failed with status code 400") {
    //           this.$swal("Check Input Data", "", "error");
    //         } else {
    //           this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
    //         }
    //       });
    //   }
    // },
    getProducts() {
      const loadingComponent = this.$loading.open({});  
      RestAPI.getClinicProductsPriceType('')
        .then((res) => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.activeproducts = res.data;
          loadingComponent.close();
          // this.inactiveproducts = res.data.inactiveproducts;
        })
        .catch((error) => {
          loadingComponent.close();
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });

        
    },
   

    updateProductForm(data) {
      this.saveAction = false;
      this.updateAction = true;
      this.priceTypeID = data.ID,
      this.priceTypeName = data.NAME;
      this.oldPriceTypeName = data.NAME;
      this.price1 = data.PRICE1;
      this.plus1 = data.PLUS1;
      this.price2 = data.PRICE2;
      this.plus2 = data.PLUS2;
      this.price3 = data.PRICE3;
      this.plus3 = data.PLUS3;
      this.price4 = data.PRICE4;
      this.plus4 = data.PLUS4;
      this.price5 = data.PRICE5;
      this.plus5 = data.PLUS5;
    },
    openSaveBranchForm() {

      this.saveAction = true;
      this.updateAction = false;
      this.priceTypeName = null;
      this.price1 = null;
      this.plus1 = null;
      this.price2 = null; 
      this.plus2 = null;
      this.price3 = null;
      this.plus3 = null;
      this.price4 = null;
      this.plus4 = null;
      this.price5 = null;
      this.plus5 = null;
    },
    // updateProduct() {
    //   // console.log("selectedHarvesttype:" + JSON.stringify(this.selectedHarvesttype))
    //   if(!this.disabledstate){ // no harvest
    //     if (
    //       this.productname === null ||
    //       this.productnameen === null ||
    //       this.unit === null ||
    //       this.selectedType === null
    //     ) {
    //       this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
    //       return false;
    //     }
    //   }else{ // harvest
    //     if ( 
    //       this.productname === null ||
    //       this.productnameen === null ||
    //       this.unit === null ||
    //       this.selectedType === null ||
    //       this.selectedHarvesttype.ID === null
    //     ) {
    //       this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
    //       return false;
    //     }

    //   }
      

    //   var params = {
    //     productid: this.productid,
    //     productname: this.productname,
    //     oldproductname: this.oldproductname,
    //     productnameen: this.productnameen,
    //     oldproductnameen: this.oldproductnameen,
    //     typeid: this.selectedType.ID,
    //     unit: this.unit,
    //     harvesttype: this.disabledstate ? this.selectedHarvesttype.ID : 2,
    //     photoname: this.photoname,
    //     username: this.username,
    //   };

    //   // console.log("pa: " + JSON.stringify(params));

    //   RestAPI.updateProduct(params)
    //     .then((res) => {
    //       // console.log("data: "+ JSON.stringify(res.data))
    //       if (res.data == "duplicate productname") {
    //         this.$swal("ຊື່ສິນຄ້າຊ້ຳ", "-", "error");
    //         return false;
    //       }

    //       this.photopreview = null;
    //       this.activeTab = 1;
    //       this.saveAction = true;
    //       this.updateAction = false;
    //       this.branchname = null;
    //       this.countryid = null;
    //       this.provinceid = null;
    //       this.getProducts();
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       if (error == "Error: Request failed with status code 400") {
    //         this.$swal("Check Input Data", "", "error");
    //       } else {
    //         this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
    //       }
    //     });
      
    // },
    

    
    getImgUrl(photoname) {
      var photopreview = photoname
        ? this.photopath + photoname
        : this.photopath + "unknown.png";
      // console.log("photoname: " + photoname)
      // console.log("photopreview: " + photopreview)
      return photopreview;
    },
    productTypeSelectedSearch() { 
      const loadingComponent = this.$loading.open({}); 
      // console.log("productTypeSelectedSearch");
      // console.log("this.selectedTypeSearch.ID: " + this.selectedTypeSearch.ID);
      // this.selectedTypeSearch = null;
      this.search = null;
      this.selectedHarvestSearch = null;
      if (this.selectedTypeSearch) {
        var params = {
          typeid: this.selectedTypeSearch.ID,
        };
        RestAPI.clinicProductTypeSelectedSearch_PriceType(params)
          .then((res) => {
            this.activeproducts = res.data;
            loadingComponent.close();
            // console.log("res: " + JSON.stringify(res.data));
          })
          .catch((error) => {
            console.log(error);
            loadingComponent.close();
            this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
          });
      } else {
        this.getProducts();
      }
    },
    
    print() {
      window.print();
    },
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    
    // this.getProducts();
    this.getProductTypes();
    this.getProductPriceType();
    // this.getResponseUser();
    // this.getAllProvince();

  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.button-wrapper {
  display: block; /* Ensures each button is on a new line */  
  margin-bottom: 5px; /* Adds spacing between buttons */
}

</style>
